import type { JSX, PropsWithChildren } from 'react';
import { useEffect, useState } from 'react';

import { AppRenderContextProvider } from './context';

// eslint-disable-next-line @typescript-eslint/ban-types
export function AppRenderInfoProvider({ children }: PropsWithChildren<{}>): JSX.Element | null {
	const [firstRender, setFirstRender] = useState(true);

	useEffect(() => {
		setFirstRender(false);
	}, []);

	return <AppRenderContextProvider value={{ firstRender }}>{children}</AppRenderContextProvider>;
}
